function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* global analytics */
import React, { memo, useCallback, useRef } from "react";
import { Configure, InstantSearch } from "react-instantsearch-dom";
import algoliasearch from "algoliasearch/lite";

var SearchClient = /*#__PURE__*/function () {
  function SearchClient(algoliaAppId, algoliaPublicApiKey) {
    var _this = this;

    _classCallCheck(this, SearchClient);

    _defineProperty(this, "searchForFacetValues", function () {
      var _this$index;

      return (_this$index = _this.index).searchForFacetValues.apply(_this$index, arguments);
    });

    this.algoliaClient = algoliasearch(algoliaAppId, algoliaPublicApiKey);
  }

  _createClass(SearchClient, [{
    key: "search",
    value: function search(requests) {
      var shouldSearch = requests.some(function (_ref) {
        var query = _ref.params.query;
        return query !== "";
      });

      if (shouldSearch) {
        return this.algoliaClient.search(requests);
      }

      return Promise.resolve({
        results: [{
          hits: []
        }]
      });
    }
  }]);

  return SearchClient;
}();

var AlgoliaConfig = function AlgoliaConfig(_ref2) {
  var algoliaAppId = _ref2.algoliaAppId,
      algoliaPublicApiKey = _ref2.algoliaPublicApiKey,
      algoliaProductIndex = _ref2.algoliaProductIndex,
      children = _ref2.children,
      _ref2$disableAnalytic = _ref2.disableAnalytics,
      disableAnalytics = _ref2$disableAnalytic === void 0 ? false : _ref2$disableAnalytic;
  var searchClient = useRef(new SearchClient(algoliaAppId, algoliaPublicApiKey));
  var handleSearchStateChange = useCallback(function (searchState) {
    if (typeof analytics !== "undefined") {
      var search = "?query=".concat(searchState.query);
      analytics.page("Search", {
        search: search
      });
    }
  }, []);
  return /*#__PURE__*/React.createElement(InstantSearch, {
    searchClient: searchClient.current,
    indexName: algoliaProductIndex,
    onSearchStateChange: handleSearchStateChange
  }, /*#__PURE__*/React.createElement(Configure, {
    analytics: !disableAnalytics
  }), children);
};

var AlgoliaConfigMemo = /*#__PURE__*/memo(AlgoliaConfig);
export { AlgoliaConfig, AlgoliaConfigMemo };